import { RootState } from '../store';

const selectUnreadSupportMessagesCount = (state: RootState): number => state.chat.common.unreadSupportMessagesCount;
const selectUnreadNotificationsCount = (state: RootState): number => state.chat.common.unreadNotificationsCount;

export const chatSelectors = {
  selectUnreadNotificationsCount,
  selectUnreadSupportMessagesCount,
};
